import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { GetMessageErrorReportsResponse, ReportsFilter } from '../types';
import { GetMessageErrorSummaryReportsResponse } from '../api/types';

export type ReportsState = {
  messageErrorReports: GetMessageErrorReportsResponse | null;
  messageErrorSummaryReports: GetMessageErrorSummaryReportsResponse | null;
  filter: ReportsFilter;
  loading: boolean;
  error: string | null;
};

const initialState: ReportsState = {
  messageErrorReports: null,
  messageErrorSummaryReports: null,
  filter: {
    startDateInterval: dayjs().subtract(30, 'days').startOf('day').toISOString(),
    endDateInterval: dayjs().endOf('day').toISOString(),
  },
  loading: false,
  error: null,
};

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    setMessageErrorReports: (state, action: PayloadAction<GetMessageErrorReportsResponse>) => {
      state.messageErrorReports = action.payload;
    },
    setMessageErrorSummaryReports: (
      state,
      action: PayloadAction<GetMessageErrorSummaryReportsResponse>,
    ) => {
      state.messageErrorSummaryReports = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    changeFilter: (state, action: PayloadAction<Partial<ReportsFilter>>) => {
      state.filter = { ...state.filter, ...action.payload };
    },
    resetReports: state => {
      state.messageErrorReports = null;
      state.messageErrorSummaryReports = null;
      state.filter = initialState.filter;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setMessageErrorReports,
  setMessageErrorSummaryReports,
  setLoading,
  setError,
  changeFilter,
  resetReports,
} = reportsSlice.actions;

export default reportsSlice.reducer;
